"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionProvider = exports.useSessionContext = exports.SessionContext = void 0;
var react_1 = __importStar(require("react"));
var ApiKey_1 = require("../ApiKey");
exports.SessionContext = (0, react_1.createContext)({ loading: true });
var useSessionContext = function () { return (0, react_1.useContext)(exports.SessionContext); };
exports.useSessionContext = useSessionContext;
var SessionProvider = function (_a) {
    var _b = _a.hideLoadingStateOnSessionChange, hideLoadingStateOnSessionChange = _b === void 0 ? false : _b, children = _a.children;
    var _c = (0, react_1.useState)({ loading: true }), session = _c[0], updateSession = _c[1];
    (0, react_1.useEffect)(function () {
        var cleanupListener = ApiKey_1.apiKeyManager.addSessionChangedListener(function () {
            if (!hideLoadingStateOnSessionChange) {
                updateSession({ loading: true });
            }
            ApiKey_1.apiKeyManager
                .getApiKey()
                .then(function (token) { return updateSession({ loading: false, token: token }); })
                .catch(function () { return updateSession({ loading: false }); });
        });
        ApiKey_1.apiKeyManager
            .getApiKey()
            .then(function (token) { return updateSession({ loading: false, token: token }); })
            .catch(function () { return updateSession({ loading: false }); });
        return function () { return cleanupListener(); };
    }, []);
    return react_1.default.createElement(exports.SessionContext.Provider, { value: session }, children);
};
exports.SessionProvider = SessionProvider;
//# sourceMappingURL=index.js.map